import React, { useCallback } from 'react';

import { Box, Text, Stack, Select, TextField } from 'src/components/matchbox';
import { Heading } from 'src/components/text';
import { useAnalyticsReportContext } from 'src/pages/analyticsReport/context/AnalyticsReportContext';
import { useAlertForm } from '../useAlertForm';

export default function Condition() {
  const {
    state: {
      conditionData: { condition, alertThreshold, precision }
    },
    dispatch
  } = useAlertForm();

  const { state: reportOptions, actions } = useAnalyticsReportContext();
  const { refreshReportOptions } = actions;

  const handleConditionChange = useCallback(
    (e) => {
      dispatch({
        type: 'UPDATE_CONDITION_DATA',
        data: { condition: e.target.value === 'Select' ? undefined : e.target.value }
      });
    },
    [dispatch]
  );

  const handleAlertThresholdChange = useCallback(
    (e) => {
      dispatch({
        type: 'UPDATE_CONDITION_DATA',
        data: { alertThreshold: e.target.value }
      });
    },
    [dispatch]
  );

  const handlePrecisionChange = useCallback(
    (e) => {
      refreshReportOptions({ ...reportOptions, precision: e.target.value.toLowerCase() });
      dispatch({
        type: 'UPDATE_CONDITION_DATA',
        data: { precision: e.target.value }
      });
    },
    [dispatch, refreshReportOptions, reportOptions]
  );

  return (
    <Stack>
      <Heading as="h4">Condition Configurations</Heading>
      <Box width="600px">
        <Text fontSize="18px">Define the alert conditions.</Text>
      </Box>
      <Box display="flex">
        <Box display="flex">
          <Box mr="20px" minWidth="140px">
            <Select
              label="Comparison"
              required
              onChange={handleConditionChange}
              value={condition}
              options={[
                'Select',
                {
                  value: 'above',
                  label: 'Above'
                },
                {
                  value: 'below',
                  label: 'Below'
                }
              ]}
            />
          </Box>
          <Box mr="20px">
            <TextField
              type="number"
              label="Alert Threshold"
              placeholder="%"
              required
              value={alertThreshold}
              onChange={handleAlertThresholdChange}
            />
          </Box>
          <Box>
            <Select
              label="Alert Precision"
              onChange={handlePrecisionChange}
              value={precision}
              options={[
                {
                  value: 'Hour',
                  label: '1 Hour'
                },
                {
                  value: 'Day',
                  label: '1 Day'
                }
              ]}
            />
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
